// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".benefit-intro-box{color:#26292d;font-size:.14rem;height:1.93rem;line-height:.2rem;margin:.2rem;overflow:scroll;overflow:-moz-scrollbars-none}.benefit-intro-box::-webkit-scrollbar{width:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
